import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";



class Login extends Component {

  state={
    username: "",
    pass: "",
  };

  render() {
    if(this.props.authed){
      return (
        <Redirect to={this.props.redirect} />
      );
    }else {
      return (
        <div className="login">
          <div className="login__form">
            <div className="login__title">LOGIN</div>
            <div className="login__info">Please use your username and password to login</div>
            <form onSubmit={(e) => {this.props.login(this.state.username,this.state.pass);e.preventDefault();}}>
              <input className="login__username" placeholder="username" value={this.state.username} onChange={(e) => this.setState({username: e.target.value})} />
              <input type="password" className="login__pass" placeholder="password" value={this.state.pass} onChange={(e) => this.setState({pass: e.target.value})} />
              <input className="button" type="submit" value="Login"/>
            </form>
          </div>
        </div>
      );
    }
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js